import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@sunbit-dev/translations';
import * as styles from './styles';
import { SupportPopupProps } from './models';
import { newPopup as Popup } from '@sunbit-dev/web-ui-lib';

export const SupportPopup = styled(({ className, onClose, noLightBox }: SupportPopupProps) => {
  const onCallClick = useCallback(() => {
    window.location.href = 'tel:8557786248';
  }, []);

  const { t } = useTranslation('components', { keyPrefix: 'support_popup' });

  return (
    <Popup
      {...{
        className,
        grayButtonAction: onClose,
        blueButtonAction: onCallClick,
        grayButtonText: t('close_button'),
        blueButtonText: t('call_button'),
        blueButtonImg: 'phone',
        boldText: t('title'),
        dataAt: 'support-popup',
        dataTestId: 'support-popup',
        noLightBox,
      }}
    >
      {((t('hours', { returnObjects: true }) as []) || []).map((text, index) => (
        <p key={index} className="row">
          {text}
        </p>
      ))}
    </Popup>
  );
})`
  ${styles.SupportPopup}
`;
